import { render, staticRenderFns } from "./FoodCourtReceta.vue?vue&type=template&id=564c8462"
import script from "./FoodCourtReceta.vue?vue&type=script&lang=js"
export * from "./FoodCourtReceta.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtReceta.vue?vue&type=style&index=0&id=564c8462&prod&lang=scss"
import style1 from "./FoodCourtReceta.vue?vue&type=style&index=1&id=564c8462&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports